export function apiUrl(path) {
	const base = (process.env.VUE_APP_API_BASE_URL || '').replace(/\/$/, '');
	return `${base}${path.startsWith('/') ? '' : '/'}${path}`;
}
